/**
 * TÜRKÇE SAYI BİÇİMLEME — ekrana basılan her sayı buradan geçmeli.
 *
 * `toFixed()` ondalık ayracı NOKTA yazar. Türkçe okumada nokta BİNLİK
 * ayraçtır: üretim ekranında reçete malzemesi `(1.5).toFixed(3)` → "1.500"
 * olarak çıkıyor ve **1.500 birim** sanılıyordu (kullanıcı, 2026-09-22).
 * Aynı hata parada da var: "336.00 TL".
 *
 * `toLocaleString('tr-TR')` ondalığı VİRGÜL, binliği NOKTA yapar — yani
 * "1,5" ve "1.500,00". Ayrım kaybolmuyor.
 */

const sayiya = (deger) => {
  const n = typeof deger === 'number' ? deger : parseFloat(deger);
  return Number.isFinite(n) ? n : null;
};

/**
 * Miktar/oran gibi sayılar. Sondaki gereksiz sıfırlar ATILIR: "1,5" yazar,
 * "1,500" değil — üç haneli sabit gösterim binlik ayraç izlenimini
 * güçlendiriyordu.
 * @param {number|string} deger
 * @param {number} azami  en fazla kaç ondalık (varsayılan 3)
 * @param {string} bos    sayıya çevrilemezse basılacak metin
 */
export const trSayi = (deger, azami = 3, bos = '—') => {
  const n = sayiya(deger);
  if (n === null) return bos;
  let basamak = azami;
  // SIFIR OLMAYAN BİR MİKTAR "0" GÖRÜNMEMELİ. Reçetelerde 0,0002 / 0,0005 /
  // 0,0228 gibi kalemler var (ERP.md: 24 malzeme 0,001'in katı değil) ve üç
  // haneye yuvarlayınca hepsi "0" oluyordu — eski `toFixed(3)` de "0.000"
  // yazıyordu, yani bu hata düzeltmeyle GELMEDİ, düzeltmeyle KALKIYOR.
  // Gerekirse basamak açılır; üst sınır anlamsız kuyruk basmasın diye var.
  if (n !== 0) {
    while (basamak < 8 && Number(n.toFixed(basamak)) === 0) basamak += 1;
  }
  return n.toLocaleString('tr-TR', { maximumFractionDigits: basamak });
};

/**
 * Para: HER ZAMAN iki ondalık (muhasebede "12,5 TL" eksik görünür).
 * Para birimi kodu çağıranın işi — Vera fontunda ₺ yok, ERP genelinde
 * tutarlar kodla yazılıyor (bkz. dekont.py).
 */
export const trPara = (deger, bos = '—') => {
  const n = sayiya(deger);
  if (n === null) return bos;
  return n.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

/**
 * Özet tutar: binlik ayraçlı, KURUŞSUZ ("1.692.171"). Sayım listesi gibi
 * milyonlarca liralık toplamlar kuruşla ve noktalı (`toFixed`) yazılınca
 * okunmuyordu (kullanıcı, 2026-10-03). Yalnızca ÖZET gösterim içindir —
 * belge/ekstre tutarları `trPara` ile iki haneli kalır.
 */
export const trTutar = (deger, bos = '—') => {
  const n = sayiya(deger);
  if (n === null) return bos;
  return Math.round(n).toLocaleString('tr-TR', { maximumFractionDigits: 0 });
};
